import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function StackValue() {
  const items = ['6 Tomos', '6 Bonos', 'Acceso inmediato', 'Actualizaciones futuras'];
  return <section className="py-16 md:py-24 px-4 bg-surface" data-id="element-302">
      <div className="max-w-3xl mx-auto" data-id="element-303">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-304">
          <h2 className="text-3xl md:text-4xl font-black text-slate-dark" data-id="element-305">
            Todo lo que recibes hoy
          </h2>
        </motion.div>

        <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-8 md:p-12" data-id="element-306">
          <ul className="space-y-6 mb-8" data-id="element-307">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center justify-between border-b border-gray-100 pb-4 last:border-0 last:pb-0" data-id="element-308">
                <div className="flex items-center gap-3" data-id="element-309">
                  <CheckCircle2 className="w-6 h-6 text-brand-green" data-id="element-310" />
                  <span className="text-lg font-medium text-slate-dark" data-id="element-311">
                    {item}
                  </span>
                </div>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center pt-8 border-t border-gray-200" data-id="element-312">
            <p className="text-slate font-medium mb-2" data-id="element-313">Valor estimado:</p>
            <p className="text-3xl font-bold text-slate-light line-through decoration-red-500/50" data-id="element-314">
              $8.370 UYU
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}